import React from "react";
import { Button } from "aible";

import { LineInput } from "components/Inputs/LineInput";

import styles from "./style.module.css";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

export default class LookerSettingsModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      aible_looker_models_repo_uuid: undefined,
      aible_workspace_uuid: undefined,
      aible_bitbucket_creds_user: undefined,
      aible_bitbucket_creds_secret: undefined,
      aible_model_file: undefined,
      aible_looker_project_name: undefined
    };
  }

  getValue(name) {
    const { userAttributes } = this.props;

    return this.state?.[name] !== undefined
      ? this.state?.[name]
      : userAttributes?.value === undefined
        ? undefined
        : userAttributes.value.find((u) => u.name === name)?.value;
  }

  render() {
    const { isOpen, updateIsOpen, saveSettings } = this.props;

    const topLabelStyle = { top: "-14px", color: "#333", fontWeight: "bold" };

    return (
      <div id={"LookerSettingsModal"}>
        <Dialog open={isOpen === true} onOpenChange={() => updateIsOpen(false)}>
          <DialogContent size="xl">
            <DialogHeader>
              <DialogTitle>{"Looker Settings"}</DialogTitle>
            </DialogHeader>
            <div className={styles.iSetting}>
              <LineInput
                topLabel={"Looker Project Name"}
                labelStyle={topLabelStyle}
                value={this.getValue("aible_looker_project_name")}
                onChange={(val) => this.setState({ aible_looker_project_name: val })}
              />
            </div>
            <div className={styles.iSetting}>
              <LineInput
                topLabel={"Model File Name"}
                labelStyle={topLabelStyle}
                value={this.getValue("aible_model_file")}
                onChange={(val) => this.setState({ aible_model_file: val })}
              />
            </div>
            <div className={styles.iSetting}>
              <LineInput
                topLabel={"Looker Models Repository UUID"}
                labelStyle={topLabelStyle}
                value={this.getValue("aible_looker_models_repo_uuid")}
                onChange={(val) => this.setState({ aible_looker_models_repo_uuid: val })}
              />
            </div>
            <div className={styles.iSetting}>
              <LineInput
                topLabel={"Workspace UUID"}
                labelStyle={topLabelStyle}
                value={this.getValue("aible_workspace_uuid")}
                onChange={(val) => this.setState({ aible_workspace_uuid: val })}
              />
            </div>
            <div className={styles.iSetting}>
              <LineInput
                topLabel={"Bitbucket User Credentials"}
                labelStyle={topLabelStyle}
                value={this.getValue("aible_bitbucket_creds_user")}
                onChange={(val) => this.setState({ aible_bitbucket_creds_user: val })}
              />
            </div>
            <div className={styles.iSetting}>
              <LineInput
                topLabel={"Bitbucket User Secret"}
                labelStyle={topLabelStyle}
                value={this.getValue("aible_bitbucket_creds_secret")}
                onChange={(val) => this.setState({ aible_bitbucket_creds_secret: val })}
              />
            </div>
            <DialogFooter>
              <Button type="secondary" onClick={() => updateIsOpen(false)}>
                {"Close"}
              </Button>
              <Button type="primary" onClick={() => saveSettings(this.state)}>
                {"Save"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}
